<template>
  <div class="oneui">
    <div>
      <ul class="nameWrapper" :style="`grid-template-columns: 1fr;`">
        <li></li>
        <li class="current">
          <span>{{$t('pages.settings.account')}}</span>
        </li>
        <li></li>
      </ul>
    </div>
    <div class="pageWrapper">
      <div class="page">
        <div class="ul">
          <div class="li">
            <span>
              <center>Email: {{ email }}</center>
            </span>
          </div>
          <SettingsButton path="/settings/account/changePin" text="pages.settings.resetPIN" />
          <!-- <SettingsButton path="/handlePatreon" text="pages.settings.linkPatreon" /> -->
          <!-- <SettingsButton text="pages.settings.changePassword" /> -->
          <SettingsButton path="/logout" text="pages.settings.logout" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SettingsButton from "../../components/SettingButton";
export default {
  name: "SettingsAccount",
  components: {
    SettingsButton
  },
  computed: {
    // The parent record is not there yet while the family data is loading,
    // and there is no parent at all before the account is set up.
    email() {
      const parent = this.$root.$data.parent;
      if (!parent) return "";
      const user = parent.get("user");
      return user ? user.get("email") || "" : "";
    }
  }
};
</script>